import React, { useState } from "react";
import { motion } from "framer-motion";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import ReactMarkdown from 'react-markdown';

const Settings = () => {
    const [locationAllowed, setLocationAllowed] = useState(false);
    const [isPDPAModalOpen, setIsPDPAModalOpen] = useState(false);

    const pdpaContent = `เว็บไซต์ **Postperty.com** โดยครอบคลุมประเด็นสำคัญต่าง ๆ เช่น นโยบายความเป็นส่วนตัว (Privacy Policy) การขอความยินยอม (Consent) และมาตรการรักษาความปลอดภัยของข้อมูล (Data Security)  

### 1. **นโยบายความเป็นส่วนตัว (Privacy Policy)**  
**Postperty.com** มุ่งมั่นในการคุ้มครองข้อมูลส่วนบุคคลของผู้ใช้งานตามกฎหมาย PDPA (พระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล พ.ศ. 2562) นโยบายนี้อธิบายถึงวิธีการเก็บรวบรวม ใช้ และเปิดเผยข้อมูลส่วนบุคคลของคุณ  

#### ข้อมูลที่เรารวบรวม  
- ข้อมูลส่วนบุคคล เช่น ชื่อ นามสกุล ที่อยู่ เบอร์โทรศัพท์ อีเมล  
- ข้อมูลบัญชีผู้ใช้งาน เช่น ชื่อผู้ใช้งาน (Username) และรหัสผ่าน (Password)  
- ข้อมูลการใช้งานเว็บไซต์ เช่น ประวัติการเข้าชม (Log Data) และคุกกี้ (Cookies)  
- ข้อมูล ตำแหน่ง พิกัด GPS ที่ได้ จากอุปกรณ์ สื่อสาร ในขณะที่ลูกค้ากำลังใช้งาน เวปไซต์

#### วัตถุประสงค์ของการใช้ข้อมูล  
- เพื่อการลงทะเบียนและให้บริการบนเว็บไซต์  
- เพื่อการติดต่อสื่อสารและให้ข้อมูลเกี่ยวกับบริการ  
- เพื่อการปรับปรุงและพัฒนาบริการของเรา  
- เพื่อการตลาดและเสนอโปรโมชันต่าง ๆ (หากได้รับความยินยอมจากคุณ)  

#### การเปิดเผยข้อมูล  
เราจะไม่เปิดเผยข้อมูลส่วนบุคคลของคุณให้กับบุคคลที่สามโดยไม่ได้รับความยินยอมจากคุณ ยกเว้นในกรณีที่กฎหมายกำหนด  

#### สิทธิ์ของคุณ  
คุณมีสิทธิ์ดังต่อไปนี้:  
- ขอเข้าถึงข้อมูลส่วนบุคคลของคุณ  
- ขอแก้ไขข้อมูลส่วนบุคคลของคุณ  
- ขอลบข้อมูลส่วนบุคคลของคุณ  
- ถอนความยินยอมในการใช้ข้อมูลส่วนบุคคลของคุณ  

#### การติดต่อ  
หากมีคำถามหรือต้องการใช้สิทธิ์ตามกฎหมาย PDPA กรุณาติดต่อเราที่:  
- อีเมล: chanwit@postperty.com  
- เบอร์โทรศัพท์: 091-0920333

---

### 2. **การขอความยินยอม (Consent)**  
เมื่อผู้ใช้งานลงทะเบียนหรือใช้บริการบนเว็บไซต์ **Postperty.com** จะมีการแสดงข้อความขอความยินยอมดังนี้:  

> "เพื่อให้การให้บริการเป็นไปอย่างมีประสิทธิภาพ ทางเว็บไซต์ Postperty.com จำเป็นต้องเก็บรวบรวม ใช้ และเปิดเผยข้อมูลส่วนบุคคลของคุณตามนโยบายความเป็นส่วนตัว คุณสามารถอ่านรายละเอียดเพิ่มเติมได้ที่ [ลิงก์นโยบายความเป็นส่วนตัว] หากคุณยินยอม กรุณากดปุ่ม 'ยอมรับ' หรือดำเนินการต่อไปเพื่อใช้บริการ"  

**หมายเหตุ**:  
- ผู้ใช้งานสามารถถอนความยินยอมได้ตลอดเวลาโดยติดต่อเราผ่านช่องทางที่ระบุในนโยบายความเป็นส่วนตัว

### 3. **มาตรการรักษาความปลอดภัยของข้อมูล (Data Security)**  
**Postperty.com** มีมาตรการรักษาความปลอดภัยของข้อมูลส่วนบุคคลดังนี้:  
1. **การเข้ารหัสข้อมูล (Encryption)**: ข้อมูลส่วนบุคคลทั้งหมดจะถูกเข้ารหัสทั้งในระหว่างการส่งและจัดเก็บ  
2. **การควบคุมการเข้าถึง (Access Control)**: จำกัดการเข้าถึงข้อมูลส่วนบุคคลเฉพาะผู้ที่มีความจำเป็นต้องรู้เท่านั้น  
3. **การตรวจสอบระบบ (Audit)**: มีการตรวจสอบระบบอย่างสม่ำเสมอเพื่อป้องกันการเข้าถึงข้อมูลโดยไม่ได้รับอนุญาต  
4. **การฝึกอบรมพนักงาน**: พนักงานทุกคนจะได้รับการฝึกอบรมเกี่ยวกับการคุ้มครองข้อมูลส่วนบุคคลตามกฎหมาย PDPA  

---

### 4. **แผนรับมือกรณีข้อมูลรั่วไหล (Data Breach Response Plan)**  
หากเกิดกรณีข้อมูลรั่วไหล **Postperty.com** จะดำเนินการดังนี้:  
1. **ตรวจสอบและประเมินสถานการณ์**: ทีมงานจะตรวจสอบสาเหตุและขอบเขตของเหตุการณ์  
2. **แจ้งสำนักงานคณะกรรมการคุ้มครองข้อมูลส่วนบุคคล (สคส.)**: จะแจ้งเหตุการณ์ภายใน 72 ชั่วโมงหลังจากทราบเหตุ  
3. **แจ้งผู้ใช้งานที่ได้รับผลกระทบ**: หากมีความเสี่ยงสูงต่อสิทธิเสรีภาพของผู้ใช้งาน จะแจ้งให้ผู้ใช้งานทราบพร้อมคำแนะนำในการป้องกันตนเอง  
4. **แก้ไขและป้องกันการเกิดซ้ำ**: จะดำเนินการแก้ไขจุดบกพร่องและปรับปรุงระบบเพื่อป้องกันการเกิดซ้ำ  

---

### 5. **การแต่งตั้ง DPO (เจ้าหน้าที่คุ้มครองข้อมูลส่วนบุคคล)**  
**Postperty.com** จะแต่งตั้ง DPO เพื่อดูแลการปฏิบัติตามกฎหมาย PDPA โดย DPO จะมีหน้าที่ดังนี้:  
- ให้คำแนะนำเกี่ยวกับการคุ้มครองข้อมูลส่วนบุคคล  
- ตรวจสอบการปฏิบัติตามกฎหมาย PDPA  
- เป็นผู้ประสานงานกับสำนักงานคณะกรรมการคุ้มครองข้อมูลส่วนบุคคล (สคส.)
`;

    const handleAllowLocationAccess = () => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    setLocationAllowed(true);
                    Swal.fire(
                        "สำเร็จ!",
                        "การเข้าถึงตำแหน่งที่ตั้งได้รับอนุญาต",
                        "success"
                    );
                    console.log('Position:', position);
                },
                (error) => {
                    let errorMessage = '';
                    switch (error.code) {
                        case error.PERMISSION_DENIED:
                            errorMessage = "การเข้าถึงตำแหน่งที่ตั้งถูกปฏิเสธโดยผู้ใช้ กรุณาดูยูทูปสอนเพื่อวิธีแก้ไขอนุญาตการเข้าถึงตำแหน่งของท่าน";
                            break;
                        case error.POSITION_UNAVAILABLE:
                            errorMessage = "ไม่สามารถระบุตำแหน่งได้";
                            break;
                        case error.TIMEOUT:
                            errorMessage = "การขอข้อมูลตำแหน่งเกินระยะเวลาที่กำหนด";
                            break;
                        default:
                            errorMessage = "เกิดข้อผิดพลาดในการขอตำแหน่งที่ตั้ง";
                            break;
                    }
                    Swal.fire("เกิดข้อผิดพลาด!", errorMessage, "error");
                }
            );
        } else {
            Swal.fire(
                "ไม่รองรับ",
                "เบราว์เซอร์ของคุณไม่รองรับการเข้าถึงตำแหน่งที่ตั้ง",
                "error"
            );
        }
    };

    const MenuButton = ({ label, onClick, iconSrc, extra }) => (
        <motion.div
            className="group bg-white border-2 border-gray-300 rounded-xl p-6 flex flex-col items-center justify-center cursor-pointer shadow-md hover:shadow-xl hover:border-black transition-all duration-300"
            whileHover={{ scale: 1.03, y: -4 }}
            whileTap={{ scale: 0.97 }}
            onClick={onClick}
        >
            <div className="w-16 h-16 mb-3 flex items-center justify-center bg-gradient-to-br from-gray-50 to-slate-100 rounded-xl group-hover:scale-110 transition-transform duration-300">
                <img src={iconSrc} alt={label} className="w-10 h-10" />
            </div>
            <h1 className="text-center text-base font-semibold text-black group-hover:text-gray-700 transition-colors">
                {label}
            </h1>
            {extra && <div className="mt-2">{extra}</div>}
        </motion.div>
    );

    const PDPAModal = () => (
        <div
            className={`fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-70 ${isPDPAModalOpen ? 'block' : 'hidden'}`}
            onClick={() => setIsPDPAModalOpen(false)}
        >
            <motion.div
                className="bg-white w-11/12 md:w-3/4 max-h-[90vh] overflow-y-auto rounded-2xl p-8 relative shadow-2xl border-2 border-gray-200"
                onClick={(e) => e.stopPropagation()}
                initial={{ opacity: 0, scale: 0.9 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.2 }}
            >
                <button
                    className="absolute top-6 right-6 w-10 h-10 flex items-center justify-center text-3xl text-gray-600 hover:text-white hover:bg-black rounded-full transition-all duration-200"
                    onClick={() => setIsPDPAModalOpen(false)}
                >
                    ×
                </button>
                <h2 className="text-3xl font-bold mb-6 text-black">นโยบายความเป็นส่วนตัว (PDPA)</h2>
                <div className="prose max-w-full prose-headings:text-black prose-p:text-gray-700">
                    <ReactMarkdown>{pdpaContent}</ReactMarkdown>
                </div>
            </motion.div>
        </div>
    );

    return (
        <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100">
            {/* PDPA Modal */}
            <PDPAModal />

            {/* Header Section */}
            <div className="bg-black text-white">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 text-center">
                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.5 }}
                    >
                        <h1 className="text-5xl md:text-6xl font-bold mb-4">การตั้งค่าบัญชี</h1>
                        <p className="text-lg text-gray-300 max-w-2xl mx-auto">
                            จัดการการตั้งค่าและความเป็นส่วนตัวของคุณ
                        </p>
                        <div className="mt-8 inline-flex items-center gap-2 text-sm text-gray-400">
                            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                            </svg>
                            <span>ปรับแต่งประสบการณ์การใช้งาน</span>
                        </div>
                    </motion.div>
                </div>
            </div>

            {/* Main Content */}
            <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                <MenuButton
                        label="ย้อนกลับ"
                        iconSrc="https://cdn-icons-png.flaticon.com/512/2099/2099190.png"
                        onClick={() =>
                            window.location.href = "/profiles"
                        }
                    />
                    <MenuButton
                        label="อนุญาตการเข้าถึงตำแหน่งที่ตั้ง"
                        iconSrc="https://cdn-icons-png.flaticon.com/512/17539/17539781.png"
                        onClick={handleAllowLocationAccess}
                        extra={
                            <Link
                                to="https://youtu.be/Yv21fdWMr-g"
                                target="_blank"
                                className="text-md text-red-500 underline"
                            >
                                วิธีการอนุญาต
                            </Link>
                        }
                    />
                    <MenuButton
                        label="PDPA"
                        iconSrc="https://cdn-icons-png.flaticon.com/512/9195/9195918.png"
                        onClick={() => setIsPDPAModalOpen(true)}
                    />
                    <MenuButton
                        label="การตั้งค่าความเป็นส่วนตัว"
                        iconSrc="https://cdn-icons-png.flaticon.com/512/7065/7065006.png"
                        onClick={() =>
                            Swal.fire(
                                "ยังไม่พร้อมใช้งาน",
                                "ฟังก์ชันนี้กำลังพัฒนา",
                                "info"
                            )
                        }
                    />
                    <MenuButton
                        label="การตั้งค่าความปลอดภัย"
                        iconSrc="https://cdn-icons-png.flaticon.com/512/2592/2592317.png"
                        onClick={() =>
                            Swal.fire(
                                "ยังไม่พร้อมใช้งาน",
                                "ฟังก์ชันนี้กำลังพัฒนา",
                                "info"
                            )
                        }
                    />
                    <MenuButton
                        label="การตั้งค่าเพิ่มเติม"
                        iconSrc="https://cdn-icons-png.flaticon.com/512/9195/9195918.png"
                        onClick={() =>
                            Swal.fire(
                                "ยังไม่พร้อมใช้งาน",
                                "ฟังก์ชันนี้กำลังพัฒนา",
                                "info"
                            )
                        }
                    />
                  
                </div>
            </div>
        </div>
    );
};

export default Settings;